module.exports = __webpack_public_path__ + "img/qrcode_pr.87ed5d80.jpg";